<template>
<div class="chapter">
<div class="inner_page">
<p class="center" id="dedication"><span>For Dr. Lewis J. Orphanof, scientist and friend.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 3dedication.vue?0f53d5f6